import { 
  SET_OBJECT_TYPE, 
  SHOW_LOADS, 
  HIDE_LOADS, 
  SET_OPTIONS_STATE, 
  RESET_OPTIONS_STATE, 
  SET_OBJECT_STATE,
  SHOW_3D_DIMENSIONS,
  HIDE_3D_DIMENSIONS,
  SHOW_3D_LABELS,
  ALLOW_EDIT_LOADS,
  SWITCH_3D_DIMENSIONS_REPORT
} from '@reducers/options/actions';
import { combineReducers } from 'redux';

import ground from './ground';
import panel from './panel';
import screw from './screw';
import beam from './beam';
import reinforcement from './reinforcement';
import barrier from './barrier';
import cladding from './cladding';
import nail from './nail';
import { mergeDeep } from '@services/helper.service';

const initialState = {
  type: null,

  loads: {
    display: false,
    editable: true
  },
  dimensions: {
    display: true,
    displayBeforeReport: true,
    displayHorizontally: false,
    renderForReport: false,
    showLabels: false,
  }
};

const object = (state = mergeDeep({}, initialState), action) => {
  switch (action.type) {
    case SET_OBJECT_TYPE: {
      // state.type = action.objectType;

      return mergeDeep({}, state, {
        type: action.objectType
      });
    }
    case SHOW_LOADS: {
      // state.loads.display = true;

      return mergeDeep({}, state, {
        loads: {
          display: true
        }
      });
    }
    case HIDE_LOADS: {
      // state.loads.display = false;

      return mergeDeep({}, state, {
        loads: {
          display: false
        }
      });
    }
    case ALLOW_EDIT_LOADS: {
      return mergeDeep({}, state, {
        loads: {
          editable: action.value
        }
      });
    }
    case SHOW_3D_DIMENSIONS: {
      return mergeDeep({}, state, {
        dimensions: {
          display: true
        }
      });
    }
    case HIDE_3D_DIMENSIONS: {
      return mergeDeep({}, state, {
        dimensions: {
          display: false
        }
      });
    }
    case SWITCH_3D_DIMENSIONS_REPORT: {
      if (action.beforeReport) {
        return mergeDeep({}, state, {
          dimensions: {
            displayBeforeReport: state.dimensions.display,
            display: action.value,
            renderForReport: true
          }
        });
      } else {
        return mergeDeep({}, state, {
          dimensions: {
            display: state.dimensions.displayBeforeReport,
            renderForReport: false
          }
        });
      }
    }
    case SHOW_3D_LABELS: {
      return mergeDeep({}, state, {
        dimensions: {
          showLabels: action.value
        }
      });
    }
    case SET_OPTIONS_STATE: {
      return action.state;
    }
    case RESET_OPTIONS_STATE: {
      return mergeDeep({}, initialState);
    }
    case SET_OBJECT_STATE: {
      return action.value;
    }
    default: {
      return state;
    }
  }
};

export default combineReducers({
  object,
  ground,
  panel,
  screw,
  beam,
  reinforcement,
  barrier,
  cladding,
  nail
});



// WEBPACK FOOTER //
// ./src/reducers/options/index.js